module.exports = __webpack_public_path__ + "img/img8.bbe686e5.svg";